import territoryUtils from 'utils/territoryUtils'

import getSavedSearchURL from './getSavedSearchURL'

export interface INormalizedDataForTerritoriesTable {
  name: string
  isFollowed: boolean
  breadcrumbItems: string[]
  totalPosts: number
  totalVideos: number
  avgEngagement: number
  avgViews: number
  avgEngagementVariation?: number
  avgViewsVariation?: number
  territoryId: string
  __typename: string
  href: string
  dateRange: number
  audience?: Record<string, any>
  isMetricsLoading?: boolean
  isMetricsUnavailable?: boolean
}

export function getNormalizedTerritoriesDataForTerritoriesTable(
  territoriesList,
  dateRange,
  panelId,
  hrefModifier,
  audience
): INormalizedDataForTerritoriesTable[] {
  return (territoriesList ?? [])?.map(territory => {
    const breadcrumbItems = territory?.allParents?.map(parent => parent.name).reverse()
    const shrinkedBreadcrumbItems =
      breadcrumbItems?.length > 2
        ? [breadcrumbItems?.[0], '...', breadcrumbItems?.[breadcrumbItems?.length - 1]]
        : breadcrumbItems

    function getHref() {
      const territoryRoute = territoryUtils.getTerritoryRouteWithFiltersObject({
        territoryId: territory?.territoryId,
        filtersObject: territory?.filtersObject,
        workspaceId: panelId,
      })

      if (territory?.__typename === 'SavedPostSearch') {
        return getSavedSearchURL(
          {
            id: territory?.territoryId?.split('.')?.[1],
            filters: territory?.filters,
          },
          panelId
        )
      }

      if (hrefModifier) {
        return hrefModifier(territoryRoute)
      }

      return territoryRoute
    }

    return {
      name: territory?.name,
      isFollowed: territory?.isFollowed,
      breadcrumbItems: shrinkedBreadcrumbItems,
      totalPosts: territory?.territoryPerformance?.totalPosts,
      totalVideos: territory?.territoryPerformance?.totalPosts,
      avgEngagement: territory?.territoryPerformance?.sampledMetrics?.avgEngagement,
      avgViews: territory?.territoryPerformance?.sampledMetrics?.avgViews,
      avgEngagementVariation: territory?.territoryPerformance?.sampledMetrics?.avgEngagementVariation,
      avgViewsVariation: territory?.territoryPerformance?.sampledMetrics?.avgViewsVariation,
      territoryId: territory?.territoryId,
      __typename: territory?.__typename,
      href: getHref(),
      dateRange,
      ...(audience && { audience }),
    }
  })
}
